<div class="ipm-applied-coupon-section" [class.ipm-diwali-coupon-popup]="isDiwaliSale">
    <div class="ipm-heading-model-section">
        <div class="ipm-close-icon" (click)="closeByDeviceType()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-applied-coupon-body">
        <img *ngIf="isDiwaliSale" class="ipm-diwali-coupon-diya" src="assets/imgs/bpm-diwali-hour-sale/diya.png" alt="Diwali diya">
        <div *ngIf="isDiwaliSale" class="ipm-diwali-coupon-label">Diwali Special</div>
        <div class="coupon-applied-text">
            {{couponData?.coupon?.code}} <span *ngIf="!isShowAppliedButton">Applied</span>
        </div>
        <div class="ipm-discount-amount">
            -{{couponData?.discountPrice  | currency : 'INR' : 'symbol' : '0.0-0'}} (<span *ngIf="couponData?.coupon?.discount?.quantifier === 'percentage'">{{(couponData?.coupon?.discount?.value / 100) | percent}}</span>
            <span *ngIf="couponData?.coupon?.discount?.quantifier !== 'percentage'">{{couponData?.coupon?.discount?.value | currency : 'INR' : 'symbol' : '0.0-0'}}</span> off)
        </div>
        <div class="ipm-action-btn-section" [class.ipm-diwali-action-btn-section]="isDiwaliSale" *ngIf="isShowAppliedButton">
            <button class="btn ipm-btn" (click)="applyCoupon()">
                Apply & Checkout
            </button>
        </div>
    </div>
</div>
